module.exports = __webpack_public_path__ + "static/media/sdworx.dd81d383.png";